module.exports = __webpack_public_path__ + "img/self-exclusion-mob.a698548d.png";